if (typeof debounce === 'undefined') {
  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
/**
 *  @class
 *  @function ThemeHeader
 */

if (!customElements.get('theme-header')) {
  class ThemeHeader extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.header_section = document.querySelector('.yee-header');
      this.menu = this.querySelector('#mobile-menu');
      this.toggle = this.querySelector('.mobile-toggle-wrapper');

      document.addEventListener('keyup', e => {
        if (e.code) {
          if (e.code.toUpperCase() === 'ESCAPE') {
            this.toggle.removeAttribute('open');
            this.toggle.classList.remove('active');
          }
        }
      });
      if (this.classList.contains('header-sticky--active')) {
        document.body.classList.add('header-sticky--active');
      }
      this.toggle.querySelector('.mobile-toggle').addEventListener('click', e => {
        if (this.toggle.classList.contains('active')) {
          e.preventDefault();
          document.body.classList.remove('overflow-hidden');
          this.toggle.classList.remove('active');
          this.closeAnimation(this.toggle);
        } else {
          document.body.classList.add('overflow-hidden');
          setTimeout(() => {
            this.toggle.classList.add('active');
          });
        }
      });

      // Sticky Header Class
      window.addEventListener('scroll', this.setStickyClass.bind(this), {
        passive: true,
      });

      // Mobile Menu offset
      window.addEventListener('scroll', this.setHeaderOffset.bind(this), {
        passive: true,
      });
      window.addEventListener('scroll', this.setHeaderHeight.bind(this), {
        passive: true,
      });

      window.dispatchEvent(new Event('scroll'));

      if (document.querySelector('.yee-announcement-bar')) {
        window.addEventListener('scroll', this.setAnnouncementHeight(), {
          passive: true,
        });
        window.dispatchEvent(new Event('resize'));
      }

      // Mobile Navigation transparent header support.
      setTimeout(() => {
        this.mobile_nav = document.querySelector('.header-mobile-navigation');

        if (this.mobile_nav && this.classList.contains('transparent--true')) {
          this.mobile_nav.classList.add('is-fixed');
        }
      }, 100);
      // Buttons.
      this.menu
        .querySelectorAll('summary')
        .forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
      this.menu
        .querySelectorAll('.parent-link-back--button')
        .forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
    }
    setStickyClass() {
      if (this.classList.contains('header-sticky--active')) {
        let offset = parseInt(this.getBoundingClientRect().top, 10) + document.documentElement.scrollTop;
        this.classList.toggle('is-sticky', window.scrollY >= offset && window.scrollY > 0);
      }
    }
    setAnnouncementHeight() {
      const a_bar = document.querySelector('.yee-announcement-bar');
      let h = a_bar.clientHeight;
      document.documentElement.style.setProperty('--announcement-height', h + 'px');
    }
    setHeaderOffset() {
      let h = this.header_section.getBoundingClientRect().top;
      document.documentElement.style.setProperty('--header-offset', h + 'px');
    }
    setHeaderHeight() {
      let h = this.clientHeight;
      document.documentElement.style.setProperty('--header-height', h + 'px');
    }
    onSummaryClick(event) {
      const summaryElement = event.currentTarget;
      const detailsElement = summaryElement.parentNode;
      const parentMenuElement = detailsElement.closest('.link-container');
      const isOpen = detailsElement.hasAttribute('open');
      if (this.querySelector('.parent-link-back--button')) {
        this.menu.scrollTop = 0;
      }
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
      }, 100);
    }
    onCloseButtonClick(event) {
      event.preventDefault();
      const detailsElement = event.currentTarget.closest('details');
      this.closeSubmenu(detailsElement);
    }
    closeSubmenu(detailsElement) {
      detailsElement.classList.remove('menu-opening');
      this.closeAnimation(detailsElement);
    }
    closeAnimation(detailsElement) {
      let animationStart;

      const handleAnimation = time => {
        if (animationStart === undefined) {
          animationStart = time;
        }

        const elapsedTime = time - animationStart;

        if (elapsedTime < 400) {
          window.requestAnimationFrame(handleAnimation);
        } else {
          detailsElement.removeAttribute('open');
        }
      };

      window.requestAnimationFrame(handleAnimation);
    }
  }
  customElements.define('theme-header', ThemeHeader);
}

/**
 *  @class
 *  @function FullMenu
 */
if (!customElements.get('full-menu')) {
  class FullMenu extends HTMLElement {
    constructor() {
      super();

      this.submenus = this.querySelectorAll(
        '.thb-full-menu>.menu-item-has-children:not(.menu-item-has-megamenu)>.sub-menu'
      );
    }
    connectedCallback() {
      if (!this.submenus.length) {
        return;
      }
      const _this = this;
      // resize on initial load
      document.fonts.ready.then(function () {
        window.addEventListener(
          'resize',
          debounce(function () {
            _this.resizeSubMenus();
          }, 100)
        );
      });
    }
    resizeSubMenus() {
      this.submenus.forEach(submenu => {
        let sub_submenus = submenu.querySelectorAll(':scope >.menu-item-has-children>.sub-menu');

        sub_submenus.forEach(sub_submenu => {
          let w = sub_submenu.offsetWidth,
            l = sub_submenu.parentElement.getBoundingClientRect().left + sub_submenu.parentElement.offsetWidth,
            total = w + l;

          if (total > window.innerWidth) {
            sub_submenu.parentElement.classList.add('left-submenu');
          } else if (sub_submenu.parentElement.classList.contains('left-submenu')) {
            sub_submenu.parentElement.classList.remove('left-submenu');
          }
        });
      });
    }
  }
  customElements.define('full-menu', FullMenu);
}

/* Codex support WhatsApp QR fallback */
(function () {
  function addSupportWhatsappQr() {
    var contactLink = document.querySelector(
      '.thb-full-menu .sub-menu a[role="menuitem"][href*="/pages/contact-us"]'
    );
    if (!contactLink) return;

    var contactItem = contactLink.closest('li');
    if (!contactItem) return;
    var supportMenu = contactItem.closest('ul.sub-menu');
    var supportItem = supportMenu ? supportMenu.parentElement : null;
    var existingItem = supportMenu ? supportMenu.querySelector('.yee-support-whatsapp') : null;

    if (!existingItem) {
      var item = document.createElement('li');
      item.className = 'yee-support-whatsapp';
      item.setAttribute('role', 'none');
      item.innerHTML =
        '<a class="yee-support-whatsapp__card" href="https://wa.me/message/6WZQJZ7VFMM3O1?src=qr" target="_blank" rel="noopener" role="menuitem" title="Chat with Yeelight on WhatsApp">' +
        '<img src="https://cdn.shopify.com/s/files/1/0744/6849/1548/t/46/assets/yeelight-whatsapp-qr-clean.png?v=1781183748" alt="Chat with Yeelight on WhatsApp" width="112" height="112" loading="eager" decoding="async">' +
        '<span class="yee-support-whatsapp__label">WhatsApp</span>' +
        '<span class="yee-support-whatsapp__hint">Scan or tap to chat</span>' +
        '</a>';

      contactItem.insertAdjacentElement('afterend', item);
    }

    if (supportItem && !supportItem.hasAttribute('data-yee-support-whatsapp')) {
      supportItem.setAttribute('data-yee-support-whatsapp', 'ready');
      var openSupportMenu = function () {
        supportItem.classList.add('yee-support-open');
      };
      var closeSupportMenu = function () {
        supportItem.classList.remove('yee-support-open');
      };

      supportItem.addEventListener('mouseenter', openSupportMenu);
      supportItem.addEventListener('mouseover', openSupportMenu);
      supportItem.addEventListener('pointerover', openSupportMenu);
      supportItem.addEventListener('focusin', openSupportMenu);
      supportItem.addEventListener('mouseleave', closeSupportMenu);
      supportItem.addEventListener('focusout', closeSupportMenu);

      var supportTrigger = supportItem.querySelector(':scope > a');
      if (supportTrigger) {
        supportTrigger.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          supportItem.classList.toggle('yee-support-open');
        });
      }
    }
  }

  function findSupportMenuItem(target) {
    if (!target || !target.closest) return null;
    var item = target.closest('.thb-full-menu > li.menu-item-has-children');
    if (!item) return null;
    return item.querySelector('.sub-menu a[href*="/pages/contact-us"]') ? item : null;
  }

  document.addEventListener(
    'pointerover',
    function (event) {
      var item = findSupportMenuItem(event.target);
      if (item) {
        item.classList.add('yee-support-open');
      }
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      var trigger = event.target.closest && event.target.closest('.thb-full-menu > li.menu-item-has-children > a');
      var item = trigger ? findSupportMenuItem(trigger) : null;
      if (!item) return;
      event.preventDefault();
      event.stopPropagation();
      item.classList.toggle('yee-support-open');
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addSupportWhatsappQr);
  } else {
    addSupportWhatsappQr();
  }
})();
